import { FormField } from '../form.field';
import { IFormField } from '../form.interface';

export class BooleanField<T = boolean> extends FormField<T> {
  constructor(args?: IFormField<T>) {
    super({
      ...args,
      ...{ inputMethod: 'checking' }
    });
  }
}
